import { useCustomSession } from "shared/context/CustomSessionContext";
import { FALLBACK_DEFAULT_APP_ROUTE } from "shared/helpers/default-app-route/defaultAppRouteSetting";
import PageComponent from "hub/src/components/common/PageComponent";
import { getDefaultAppRoute } from "hub/src/utils/routes/getDefaultAppRoute";

const AccessDeniedPage = () => {
  const session = useCustomSession();
  const homeRoute =
    getDefaultAppRoute({
      setting: session.society?.societySettingsPublic?.defaultAppRoute,
    }) ?? FALLBACK_DEFAULT_APP_ROUTE;

  return (
    <PageComponent>
      <PageComponent.Header></PageComponent.Header>
      <PageComponent.Content>
        <div
          className="text-center py-24 px-8 h-full"
          data-testid="access-denied-page"
        >
          <p className="text-base font-semibold text-primary">Access Denied</p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-dark sm:text-5xl">
            Oops!
          </h1>
          <p className="mt-6 text-base leading-7 text-medium">
            {/* TODO: We need to either remove this eslint rule or fix it. I recommend we just remove the rule */}
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            You don't have permission to access this page.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href={session.societyUserId ? homeRoute : "/login"}
              className="text-sm font-semibold text-primary hover:text-primary-tint"
            >
              Go to {session.societyUserId ? "Home" : "login"} page{" "}
              <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>
      </PageComponent.Content>
    </PageComponent>
  );
};

export default AccessDeniedPage;
